import { isString } from 'lodash-es';
import { waitForElement } from '../waitForElement';

type WaitForElementOptions = {
  timeout?: number;
  checkEl?: (el: Element) => boolean;
};

export const waitForElements = (
  selectors: string[] = [],
  { timeout, checkEl }: WaitForElementOptions = {}
) =>
  isString(selectors)
    ? Promise.all([waitForElement(selectors, { timeout, checkEl })])
    : Promise.all(
        selectors.map((sel) => waitForElement(sel, { timeout, checkEl }))
      );
